import type { FC, PropsWithChildren } from 'react'

import { SC_H1, SC_H2, SC_H3, SC_H4, SC_H5, SC_H6 } from './styled'

export type T_Levels = 1 | 2 | 3 | 4 | 5 | 6
export type T_Weights = 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900

export type T_HeadingProps = PropsWithChildren<{
  level: T_Levels
  weight?: T_Weights
  centered?: boolean
  onClick?: () => void
}>

export const Heading: FC<T_HeadingProps> = (props) => {
  const { level } = props

  switch (level) {
  case 1: return <SC_H1 {...props} />
  case 2: return <SC_H2 {...props} />
  case 3: return <SC_H3 {...props} />
  case 4: return <SC_H4 {...props} />
  case 5: return <SC_H5 {...props} />
  case 6: return <SC_H6 {...props} />
  }
}
